import { useMemo } from 'react';
import { ExtrudeGeometry } from 'three';
import { roundTubeProfile } from './crossSections';
import { SCALE_IN_TO_UNIT } from '../types';
import { MATERIALS } from '../materials';
import { useSceneSelection } from '../selection/useSceneSelection';

const HR_OFFSET_ABOVE_RAIL_IN = 6;

interface Props {
  lengthIn: number;
  position: [number, number, number];
  rotationY: number;
  pitchAngle: number;
  refId: string;
  partNumber?: string;
  stockLengthIn?: number;
}

export function HandRailTube({
  lengthIn,
  position,
  rotationY,
  pitchAngle,
  refId,
  partNumber = 'MTR065075031',
  stockLengthIn,
}: Props) {
  const geometry = useMemo(() => {
    const g = new ExtrudeGeometry(roundTubeProfile(16), { depth: lengthIn, bevelEnabled: false });
    g.translate(0, 0, -lengthIn / 2);
    g.scale(SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT);
    return g;
  }, [lengthIn]);

  const offset = HR_OFFSET_ABOVE_RAIL_IN * SCALE_IN_TO_UNIT;
  const isCut = stockLengthIn !== undefined && stockLengthIn !== lengthIn;

  return (
    <mesh
      geometry={geometry}
      material={MATERIALS.aluminumBrushed}
      position={[position[0], position[1] + offset, position[2]]}
      rotation={[pitchAngle, rotationY, 0]}
      castShadow
      receiveShadow
      userData={{
        partNumber,
        kind: 'handrail',
        lengthIn,
        cutOnSite: isCut,
        stockLengthIn,
        refId,
      }}
      onPointerOver={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setHovered(refId);
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setHovered(null);
      }}
      onPointerDown={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setSelected(refId);
      }}
    />
  );
}
